import { parseUrl, urlToString } from "Shared/url";
import * as itemCache from "SiteLayout/CurrentPage/cache";
import * as appShell from "../AppShell";
export const ESALES_TICKET_HEADER = "X-ESales-Ticket";
export const ESALES_ACTION_HEADER = "X-ESales-Action";
export const ESALES_ADD_TO_CART_ACTION = "addtocart";
export const ESALES_CLICK_ACTION = "click";
export const AJAX_REQUEST_QUERY_STRING = "react";
export function get(url, headers = undefined) {
    return load(url, "get", undefined, headers);
}
export const serverVersionHeaderName = "X-Server-Version";
export function getItem(url, useCache = false) {
    let cachePromise = null;
    if (useCache) {
        const urlString = typeof url === "string" ? url : urlToString(url);
        const cacheItem = itemCache.get(urlString);
        if (cacheItem) {
            cachePromise = Promise.resolve(cacheItem);
        }
    }
    // Even if we use the cache we still want to get a fresh version of it
    // and update the cache
    const fetchPromise = getJson(url).then((item) => {
        const cacheItem = item;
        if (itemCache.isCacheItem(cacheItem)) {
            itemCache.set(cacheItem);
        }
        return item;
    });
    return cachePromise ? cachePromise : fetchPromise;
}
export function getItems(url) {
    return getJson(url).then((items) => {
        if (items) {
            items.forEach((i) => {
                if (itemCache.isCacheItem(i)) {
                    itemCache.set(i);
                }
            });
        }
        return items;
    });
}
export function getJson(url, headers = undefined) {
    return load(url, "get", headers).then((r) => r.json());
}
export function post(url, body = undefined, headers = undefined) {
    return load(url, "post", body, headers);
}
export function head(url, body = undefined, headers = undefined) {
    return load(url, "head", body, headers);
}
export function postJson(url, body = undefined, headers = undefined) {
    return load(url, "post", body, headers).then((r) => {
        if (!!r.redirected) {
            console.log("User has likely been logged out. Redirecting to /starpage/loggedout");
            window.location.href = "/startpage/loggedout";
        }
        return r.json();
    });
}
export function put(url, body = undefined, headers = undefined) {
    return load(url, "put", body, headers);
}
export function putJson(url, body = undefined, headers = undefined) {
    return load(url, "put", body, headers).then((r) => {
        if (!!r.redirected) {
            console.log("User has likely been logged out. Redirecting to /starpage/loggedout");
            window.location.href = "/startpage/loggedout";
        }
        return r.json();
    });
}
function load(url, method, body = undefined, headers = {}) {
    const urlObject = parseUrl(url);
    // We append the extra querystring here because we can't request the same url for Ajax as what's in
    // the browser address bar. If we use the same url, the browser will use the JSON response from the browser
    // cache to serve up to the user if the user goes back from the site and then forward to it.
    urlObject.query[AJAX_REQUEST_QUERY_STRING] = null;
    let load = fetch(urlToString(urlObject, true), {
        headers: Object.assign({
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/json",
            "X-Client-Version": CURRENT_VERSION,
        }, headers),
        credentials: "same-origin",
        method,
        body: body !== undefined ? JSON.stringify(body) : undefined,
    })
        .then((r) => {
        if (serverHasDifferentMajorVersion(r)) {
            console.info("Nuking the local caches because the server has a higher major version");
            return Promise.all([itemCache.nuke(), appShell.nuke()]).then(() => {
                // Might seem drastic to do a full page reload when we get an Ajax response since it
                // will probably interrupt the user. But a major version change means that data structures
                // differ in a way that the client has to update. Major version changes should be few and far
                // between enough to not make this a usability issue.
                window.location.reload();
                // Return never resolving promise to pause the chain so the page can reload
                return new Promise(() => null);
            });
        }
        else {
            return r;
        }
    })
        .then((r) => {
        if (r.status >= 200 && r.status < 400) {
            return r;
        }
        else {
            return Promise.reject({
                status: r.status,
            });
        }
    });
    /* For chaosMonkeyMode in non production */
    const delayNumber = (window.chaosMonkeyMode && window.chaosMonkeyMode.delay) ||
        Math.round(Math.random() * 2 * 100) / 100;
    const failNumber = (window.chaosMonkeyMode && window.chaosMonkeyMode.fail) || 0.5;
    function delay(value) {
        console.debug("Delaying request for", delayNumber, "seconds", urlToString(urlObject, true));
        return new Promise((resolve) => setTimeout(() => resolve(value), delayNumber * 1000));
    }
    function randomlyFail(value) {
        if (Math.random() < failNumber) {
            console.debug("Simulating failed request, probability: ", failNumber, urlToString(urlObject, true));
            return Promise.reject({
                status: 500,
            });
        }
        else {
            return value;
        }
    }
    if (process.env.NODE_ENV !== "production") {
        if (window.chaosMonkeyMode) {
            load = load.then(delay).then(randomlyFail);
        }
    }
    return load;
}
function serverHasDifferentMajorVersion(response) {
    // If the response is an error we might have failed to add the server version
    if (!response.headers.has(serverVersionHeaderName)) {
        console.warn("Response didn't contain a server version in header");
        return false;
    }
    const serverMajor = response.headers
        .get(serverVersionHeaderName)
        .split(".")[0];
    const clientMajor = CURRENT_VERSION.split(".")[0];
    return serverMajor !== clientMajor;
}
export function serverHasDifferentVersion(response) {
    // If the response is an error we might have failed to add the server version
    if (!response.headers.has(serverVersionHeaderName)) {
        console.warn("Response didn't contain a server version in header");
        return false;
    }
    return response.headers.get(serverVersionHeaderName) !== CURRENT_VERSION;
}
